import BaseVariantImages from './BaseVariantImages'

const VariantImages = {
  ...BaseVariantImages,
  // Logos
  Logo: require('./img/variants/bmh/logo.png'),
  LogoPrimary: require('./img/variants/bmh/logoPrimary.png'),
  // Stores
  GooglePlay: require('./img/variants/bmh/googlePlay.svg'),
  AppStore: require('./img/variants/bmh/appStore.svg'),
}

export default VariantImages
